$( document ).ready(function() {
    console.log( "correWishlist" );
  })
  
  var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
  var LOCAL_STORAGE_DELIMITER = ',';
  var BUTTON_ACTIVE_CLASS = 'btnAcactive';
  
  var selectors = {
    button: '[button-wishlist]',
    grid: '[grid-wishlist]',
  };
  
  setTimeout(function(){ 
    var butWish = document.querySelectorAll(selectors.button) || [];
    setupButtons(butWish)
  }, 2000);
  /* setInterval(function(){ 
    var butWish = document.querySelectorAll(selectors.button) || [];
    setupButtons(butWish)
  }, 1000); */
  document.addEventListener('DOMContentLoaded', function () {
    
    var buttons = document.querySelectorAll(selectors.button) || [];
    //if (buttons.length) setupButtons(buttons);
    if (buttons.length) addtoWishlist(buttons);
  
    var grid = document.querySelector(selectors.grid) || false;
    if (grid) setupGrid(grid);
  });
  
   var itemWishList = '';
  var setupGrid = function (grid) {
   /*  let url = 'https://api.sheety.co/85cc83d01a3710372f31d59d9a8dee26/wishlist/items';
  fetch(url)
  .then((response) => response.json())
  .then(json => {
    console.log(json.items)
    for (const index in json.items) {
      
      console.log(json.items[index].idCustomer);
      
    }
    console.log(json.items);
  }); */
    var wishlist = getWishlist();
    var requests = wishlist.map(function (handle) {
      console.log(handle)
      var productTileTemplateUrl = '/products/' + handle + '?view=card';
      jQuery.getJSON('/products/' + handle + '.js', function(product) {
                  console.log(product.type)
                if (product.variants[0].available == true) {
                  disabled = '';
                  varianceId = product.variants[0].id;
                  btnLabel = 'ADD TO BAG';
                } else {
                  disabled = 'disabled';
                  varianceId = '';
                  btnLabel = 'SOLD OUT';
                }
      
                  itemWishList+='<li>';
                  itemWishList+='<div class="contentWishListItem">';
                  itemWishList+='<div class="contentWishListItem-img">';
                  itemWishList+='<a href="' + product.url + '"><img src="' + product.featured_image + '"></a>';
                  itemWishList+='</div>';
                  itemWishList+='<div class="contentWishListItem-inf">';
                  itemWishList+='<h2 class="wishTitle"> <a href="' + product.url + '">' + product.title + '</a></h2>';
                  itemWishList+='<div class="contentWishListItem-inf-precio">';
                  if(product.compare_at_price_max > product.price_min){
                    itemWishList+='<p class="precioRRebaja">' +Shopify.formatMoney(product.compare_at_price_max)  + '</p>';
                    itemWishList+='<p class="precioNNormal">' + Shopify.formatMoney(product.price_min) + '</p>';
                  }else{
                    itemWishList+='<p class="precioNNormal">' + Shopify.formatMoney(product.price) + '</p>';
                  }
                 
                  itemWishList+='</div>';
                  itemWishList+='<p class="SKUITEM">' + product.variants[0].sku + '</p>';
                  itemWishList+='<p class="Vendor">' + product.vendor + '</p>';
                  itemWishList+='<button style="border: none; background: none;" type="button" aria-label="Add to wishlist" class="btnEliminarInfo" button-wishlist data-product-handle="'+product.handle+'" data-product-id="'+product.id+'">Eliminar</button>';
                  itemWishList+='</div>';
                  itemWishList+='<div class="contentWishListItem-BTN">';
                  if(jQuery.inArray("Graduable", product.tags) !== -1){
                    itemWishList+='<a href=' + product.url + ' class="graduabbbleWish">Gradúa tus lentes</a>';
                    itemWishList+='<a href="/cart/add?id[]=' + product.variants[0].id + '" class="nogradduableWish">Agregar al carrito</a>';
                  }else{
                    if(product.type == "Lentes de Contacto"){
                      itemWishList+='<a href=' + product.url + ' class="graduabbbleWish">Configurar tu graduación</a>';
                    }else{
                      itemWishList+='<a href="/cart/add?id[]=' + product.variants[0].id + '" class="nogradduableWish">Agregar al carrito</a>';
                    }
                    
                  }
                  
                  
                  itemWishList+='<button style="border: none; background: none;" type="button" aria-label="Add to wishlist" class="btnEliminarButtnS" button-wishlist data-product-handle="'+product.handle+'" data-product-id="'+product.id+'">Eliminar</button>';
                  itemWishList+='</div>';
                  itemWishList+='</div>';
                  itemWishList+='</li>';
           
                  $('#wishlist-here2').html(itemWishList);
              });
      return fetch(productTileTemplateUrl).then(function (res) {
        return res.text();
      });
    });
    Promise.all(requests).then(function (responses) {
      var wishlistProductCards = responses.join('');
      /* console.log(wishlistProductCards) */
      
      /* $(grid).html(wishlistProductCards) */
      /* grid.innerHTML = wishlistProductCards; */
      var buttons = grid.querySelectorAll(selectors.button) || [];
      //if (buttons.length) setupButtons(buttons);
      if (buttons.length) addtoWishlist(buttons);
    });
  };
  
  
  var setupButtons = function (buttons) {
    buttons.forEach(function (button) {
      /* console.log(button.dataset.productId) */
      var productHandle = button.dataset.productHandle || false;
      
      if (!productHandle) return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
      if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
      /* button.addEventListener('click', function () {
        updateWishlist(productHandle);
        button.classList.toggle(BUTTON_ACTIVE_CLASS);
      }); */
    });
  };
  var addtoWishlist = function (buttons) {
    buttons.forEach(function (button) {
      /* console.log(button.dataset.productId) */
      var productHandle = button.dataset.productHandle || false;
      
      if (!productHandle) return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
      if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
      button.addEventListener('click', function () {
        updateWishlist(productHandle);
        button.classList.toggle(BUTTON_ACTIVE_CLASS);
      });
    });
  };
  
  var getWishlist = function () {
    var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
    return [];
  };
  
  var setWishlist = function (array) {
    var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
    if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
    return wishlist;
  };
  
  var updateWishlist = function (handle) {
    var wishlist = getWishlist();
    var indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) wishlist.push(handle);
    else wishlist.splice(indexInWishlist, 1);
    return setWishlist(wishlist);
  };
  
  var wishlistContains = function (handle) {
    var wishlist = getWishlist();
    return wishlist.indexOf(handle) !== -1;
  };
  
  var resetWishlist = function () {
    return setWishlist([]);
  };
  $('body').on('click', '.btnWisssshlistPLP', function(e) {
    e.preventDefault();
    if($(this).hasClass("btnAcactive") != true){
    $(this).addClass("btnAcactive")
    console.log("SSS")
    var handle = $(this).attr("data-product-handle");
    var imagen = $(this).attr("data-image");
    var titulo = $(this).attr("data-title");
    var sku = $(this).attr("data-sku");
    var vendor = $(this).attr("data-vendor");
    $(".imgLente").attr("src",imagen)
    $(".tituloLente").html(titulo)
    $(".skuLente").html(sku)
    $(".marcaLente").html(vendor)
    updateWishlist(handle)
    $(".modalOverlayWish").attr("m-active","true");
    $(".modalWishlist").attr("m-active","true");
    $(".modalWishlist").trigger("click");
    $("#shopify-section-static-header").focus();
    $(".productitem").hide();
    setTimeout(function(){
    $(".productitem").show();
    }, 300);
    }else{
    var handle = $(this).attr("data-product-handle");
    var imagen = $(this).attr("data-image");
    var titulo = $(this).attr("data-title");
    var sku = $(this).attr("data-sku");
    var vendor = $(this).attr("data-vendor");
    $(".imgLente").attr("src",imagen)
    $(".tituloLente").html(titulo)
    $(".skuLente").html(sku)
    $(".marcaLente").html(vendor)
    updateWishlist(handle)
    $(this).removeClass("btnAcactive")
    console.log("ddd")
    $(".modalWishlist").trigger("click");
    $(".modalWishlist").focus();
    }
    });
    $('body').on('click', '.cerrarModalW', function() {
    $(".modalOverlayWish").attr("m-active","false");
    $(".modalWishlist").attr("m-active","false");
    $(".imgLente").attr("src","")
    $(".tituloLente").html("")
    $(".skuLente").html("")
    $(".marcaLente").html("")
  });